import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import accountActions from "../../../store/actions/accounts/account.actions";
import { Link, useSearchParams } from "react-router-dom";

import "../../../styles/components/dialogs/accounts/manageAccountsDialogComponent.scss";
import AlertService from "../../../services/alerts/alert.service";
import validationHelper from "../../../helpers/validation.helper";
import { useEffect, useState, useCallback } from "react";
import TextInputElementComponent from "../../../components/general/elements/inputElements/TextInputElementComponent";
import textInputModel from "../../../models/general/elements/inputElements/textInput.model";

export const ManageBusinessAccountsDialogComponent = ({ accountActions, accounts }) => {
  const [, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState("");

  const fetchAccounts = useCallback(async () => {
    try {
      await accountActions.getUsersByBusinessCustomer(); // Adjust the action to fetch all accounts
    } catch (error) {
      console.error("Error fetching accounts:", error);
    }
  }, [accountActions]);

  useEffect(() => {
    fetchAccounts();
  }, [fetchAccounts]);

  // eslint-disable-next-line no-unused-vars
  const handleUpdate = (id) => {
    const queryParams = new URLSearchParams();
    queryParams.set("d", "account");
    queryParams.set("action", "update");
    queryParams.set("id", id);

    setSearchParams(queryParams);
  };

  const handleDelete = async (email) => {
    const userChoice = await AlertService.confirm("האם אתה בטוח שברצונך למחוק חשבון זה?", "שים לב, פעולה זו בלתי הפיכה", "כן מחק", "בטל");
    if (!userChoice) return;

    const response = await accountActions.deleteAccount(email);
    if (!validationHelper.validateHttpResponse(response)) {
      AlertService.error("מחיקת חשבון נכשלה. נסה שוב.", "אנא נסה שנית מאוחר יותר");
      return;
    }
    AlertService.success("חשבון נמחק בהצלחה");
    fetchAccounts();
  };

  const getNewAccountContainerElement = () => {
    return (
      <div className="newAccountContainer">
        <Link to="?d=account&action=add" className="addAccountButton primaryButton">
          הוספה
        </Link>
      </div>
    );
  };

  const getSearchInput = () => {
    const inputProps = {
      ...textInputModel,
      name: "searchInput",
      value: searchTerm,
      placeholder: "חפש חשבון...",
      onChange: (e) => setSearchTerm(e.target.value),
      icon: <i className="fa-solid fa-magnifying-glass"></i>,
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getExistingAccountsContainerElement = () => {
    // Filter accounts based on search term
    const filteredAccounts = accounts?.filter((account) => {
      if (!searchTerm) return true;
      const searchLower = searchTerm.toLowerCase();
      const email = account.email?.toLowerCase() || "";
      const name = account.businessCustomer?.lastName?.toLowerCase() || "";
      const customerId = account.businessCustomer?.customerId?.toString() || "";
      return email.includes(searchLower) || name.includes(searchLower) || customerId.includes(searchLower);
    });

    return (
      <div className="existingAccountTable">
        <div className="tableHeader">
          <div>דוא"ל</div>
          <div>קוד חברה</div>
          <div>שם</div>
          <div>פעולות</div>
        </div>
        <div className="tableBody">
          {filteredAccounts?.map((account) => (
            <div key={account.id} className="tableRow">
              <div className="accountEmail">
                <span className="mobileLabel">דוא"ל:</span>
                <span className="accountValue">{account.email}</span>
              </div>
              <div className="accountUsername">
                <span className="mobileLabel">קוד חברה:</span>
                <span className="accountValue">{account.businessCustomer.customerId}</span>
              </div>
              <div className="accountUsername">
                <span className="mobileLabel">שם:</span>
                <span className="accountValue">{account.businessCustomer.lastName}</span>
              </div>
              <div className="accountActions">
                <span className="mobileLabel">פעולות:</span>
                <div className="actionsButtonsContainer">
                  {/* <button className="actionButton updateButton" onClick={() => handleUpdate(account.id)}>
                    <i className="fa-solid fa-pen-to-square"></i>
                  </button> */}
                  <button className="actionButton deleteButton" onClick={() => handleDelete(account.email)}>
                    <i className="fa-solid fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="dialogContainer manageAccountsDialogContainer">
      <h1>ניהול חשבונות</h1>
      {getNewAccountContainerElement()}
      <div className="searchContainer">{getSearchInput()}</div>
      {getExistingAccountsContainerElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  accounts: state.accountReducer.usersByBusiness, // Subscribe to accounts state from the reducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageBusinessAccountsDialogComponent);
